import { toRGBA } from './utils'

// TODO: (3) Refactor functions

export const shadowLow = ({ theme }) => ({
  'box-shadow': `1px 3px 5px 0 ${toRGBA(theme.colors.greys.dark, 0.5, -5)}`,
})

export const shadowMedium = ({ theme }) => ({
  'box-shadow': `2px 6px 10px 0 ${toRGBA(theme.colors.greys.dark, 0.5, -5)}`,
})

export const shadowHigh = ({ theme }) => ({
  'box-shadow': `2px 12px 20px 0 ${toRGBA(theme.colors.greys.dark, 0.5, -5)}`,
})

export const shadowLowText = ({ theme }) => ({
  'text-shadow': `1px 3px 5px ${toRGBA(theme.colors.greys.dark, 0.5, -5)}`,
})

export const shadowMediumText = ({ theme }) => ({
  'text-shadow': `2px 6px 10px ${toRGBA(theme.colors.greys.dark, 0.5, -5)}`,
})

export const shadowHighText = ({ theme }) => ({
  'text-shadow': `2px 12px 20px ${toRGBA(theme.colors.greys.dark, 0.5, -5)}`,
})

export const shadowLowDrop = ({ theme }) => ({
  filter: `drop-shadow(1px 3px 5px ${toRGBA(
    theme.colors.greys.dark,
    0.5,
    -5
  )})`,
})

export const shadowMediumDrop = ({ theme }) => ({
  filter: `drop-shadow(2px 6px 10px ${toRGBA(
    theme.colors.greys.dark,
    0.5,
    -5
  )})`,
})

export const shadowHighDrop = ({ theme }) => ({
  filter: `drop-shadow(2px 12px 20px ${toRGBA(
    theme.colors.greys.dark,
    0.5,
    -5
  )})`,
})

export const transparentUI = ({ theme }) => ({
  background: toRGBA(theme.colors.greys.dark, 0.9),
})
